import React, {Component} from 'react';

import I18n from 'app/common/i18n';

import CandidateIcon from 'app/assets/candidates-grey.svg';
import EntityIcon from 'app/assets/entity-grey.svg';

import Academies from './Academies';
import {RecentStatsCounter} from 'dk-ui-lib';

class RecentStatsGroup extends Component {
  renderRecentInfoCount(stats) {
    return (
      <div className='col-5 flex justify-around'>
        <div className='col-4'>
          <RecentStatsCounter
            count={stats.entitiesCount}
            label={I18n.t('dashboard.entities')}
            period={stats.selectedTimePeriod}
            icon={<EntityIcon className='svg-icon svg-2x'/>}
          />
        </div>
        <div className='col-4'>
          <RecentStatsCounter
            count={stats.candidatesCount}
            label={I18n.t('dashboard.candidates')}
            period={stats.selectedTimePeriod}
            icon={<CandidateIcon className='svg-icon svg-2x'/>}
          />
        </div>
      </div>
    );
  }

  render() {
    let {stats, className} = this.props;
    return (
      <div className={'flex justify-between ' + className}>
        <Academies className='col-6' academies={stats.entities}/>
        {this.renderRecentInfoCount(stats)}
      </div>
    );
  }

}

export default RecentStatsGroup;



// WEBPACK FOOTER //
// ./src/views/dashboard/RecentStatsGroup.js